import { TaskDetail } from "./task-detail";
import React from "react";

export const TaskGroup = ({ task }) => {
    return <TaskDetail key={task.key} task={task} includeDescription />;
};
